export function getShopStatus(shopDocument) {
  if (!shopDocument) return null;
  const status = shopDocument.status ?? shopDocument.shop_status ?? null;
  return typeof status === 'string' ? status.toLowerCase() : null;
}

export function isGracePeriod(shopDocument) {
  return getShopStatus(shopDocument) === 'grace';
}

export function isExpired(shopDocument) {
  return getShopStatus(shopDocument) === 'expired';
}

export function isInactive(shopDocument) {
  return getShopStatus(shopDocument) === 'inactive';
}

export function isSameShop(shopDocument, shopId) {
  if (!shopDocument || !shopId) return false;
  return String(shopDocument.id) === String(shopId);
}

export function isBasicShop(shopDocument) {
  if (!shopDocument) return false;
  return String(shopDocument.plan || '').toLowerCase() === 'basic';
}

export function getWebsiteUpgradeMessage() {
  return 'Website access is available on Premium and Enterprise plans. Upgrade your shop to continue.';
}
